import { Pipe, PipeTransform } from '@angular/core'
import { ConjugationPipe } from '../../../shared/pipes/core/conjugation.pipe'
import { NounsInterface } from '../../../shared/pipes/core/nouns.interface'

@Pipe({
    name: 'displayCountOwners',
    standalone: false
})
export class DisplayCountOwnersPipe extends ConjugationPipe implements PipeTransform {

    transform(subjects: Array<Object>, nouns?: NounsInterface, always?: boolean): string {
        return super.transform(subjects, {fiveOrMore: 'propachtovatelů', twoToFour: 'propachtovatelé', one: 'propachtovatel'}, always)
    }
}